export enum CustomerOriginType {
  Shopify = 1,
  Erp = 2,
  Sislog = 3,
  ManualRegistration = 4
}